export enum MenuList {
  DASHBOARD = "dashboard",
  HOSTERS = "hosters",
  USERS = "users",
  HOSTINGS = "hostings",
  SETTINGS = "settings",
  SUPPORT = "support",
  PROFILE = "profile",
}
